export type Social_Account_Type = {
  type: string;
  url: string;
};

export type About_Type = {
  name: string;
  title: string;
  bio: string;
  keyAchivments: string[];
  image: string;
};

export type Project_Type = {
  id: string;
  title: string;
  description: string;
  video: string;
  link: string;
};

export type Skill_Type = {
  id: string;
  name: string;
  proficiency: number;
  code: string;
};

export type Experience_Type = {
  id: string;
  company: string;
  role: string;
  achivements: string[];
  responsibilities: string[];
};

export type Education_Type = {
  id: string;
  name: string;
  degree: string;
  year: string;
};

export type Testimonial_Type = {
  id: string;
  name: string;
  description: string;
  company: string;
};

export type Contact_Type = {
  email: string;
  phone: string;
  socialAccounts: Social_Account_Type[];
};

export type Message_Type = {
  id: string;
  name: string;
  email: string;
  message: string;
};

export type Blog_Type = {
  id: string;
  title: string;
  author: string;
  summary: string;
  content: Content_Type[];
  date: number;
  type: BLOG_STATUS;
  numberOfReads?: number;
};

export enum Content_Enums {
  VIDEO = "VIDEO",
  IMAGE = "IMAGE",
  CODE = "CODE",
  TEXT = "TEXT",
  TITLE = "TITLE",
  UL = "UL",
}

export type Content_Type = {
  index: number;
  type: Content_Enums;
  content: string | string[];
};

export enum BLOG_STATUS {
  NONE = "NONE",
  Mathematics = "Mathematics",
  Physics = "Physics",
  Programming = "Programming",
}
